import styled from "styled-components";

export const ErrorText = styled.p<{ $visible: boolean }>`
  color: red;
  visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
  margin: 0;
  padding: 0;
`;
